import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    paddingBottom: 8,
    borderRightWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#dbdbdb'
  },
  content: {
    width: '100%',
    flexDirection: 'column'
  },
  subject: {
    width: '100%',
    marginBottom: 10,
    alignItems: 'flex-end',
    marginTop: 12
  },
  subjectTitle: {
    fontSize: 8,
    color: 'black',
    marginLeft: 2
  },
  subjectValue: {
    fontWeight: 'bold',
    fontSize: 8,
    color: 'black',
    textAlign: 'right',
    direction: 'rtl'
  },
  // Phone numbers mix digits and parentheses; laid out left to right they keep their order.
  subjectValueNumber: {
    fontWeight: 'bold',
    fontSize: 8,
    color: 'black',
    textAlign: 'right',
    direction: 'ltr'
  },
  subjectValueRed: {
    fontSize: 8,
    color: 'red'
  },
  phoneNumberContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingVertical: 4
  },
  hotelName: {
    width: '70%',
    alignItems: 'flex-end'
  },
  rowDirection: {
    display: 'flex',
    flexDirection: 'row-reverse',
    width: '62%'
  },
  rowDirection2: {
    display: 'flex',
    flexDirection: 'row-reverse',
    width: '38%'
  },
  rowDirection3: {
    display: 'flex',
    flexDirection: 'row-reverse',
    width: '100%'
  }
})
export default styles
